module.exports = __webpack_public_path__ + "static/media/real-time-sync@2x.bd4d94e7.png";